import {SortDirection} from '@deviceinsight/ng-ui-api-client';
import {PaginationSettings} from '@deviceinsight/ng-ui-components';

export const getInitialPaginationSettings = (sortProperty: string, sortDirection: string): PaginationSettings => {
	return {
		page: 0,
		size: 15,
		sort: {
			property: sortProperty,
			direction: sortDirection as SortDirection
		}
	};
};
